import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ClipboardList, FileSpreadsheet, Wallet, Truck, Receipt, Users, Boxes, Upload, Camera } from "lucide-react";

const TILES = {
    mr: [
        { to: "/employee/mr/place-order", icon: ClipboardList, label: "Place order on behalf", desc: "For doctors, distributors or retailers" },
        { to: "/employee/mr/drs", icon: FileSpreadsheet, label: "Daily Report Sheet", desc: "Log today's visits & outcomes" },
        { to: "/employee/mr/dues", icon: Wallet, label: "Customer dues", desc: "View outstanding by date or customer" },
        { to: "/employee/mr/expenses", icon: Camera, label: "Market expenses", desc: "Snap a receipt, log spend, accounts will reimburse" },
    ],
    packing: [
        { to: "/employee/packing", icon: Truck, label: "Packing queue", desc: "Mark items packed / out-of-stock" },
    ],
    stock: [
        { to: "/employee/stock", icon: Boxes, label: "Daily stock update", desc: "Log today's counts; edits are logged for audit" },
    ],
    accounts: [
        { to: "/employee/accounts/invoices", icon: Receipt, label: "Invoices", desc: "Create Tally-style invoices with GST" },
        { to: "/employee/accounts/uploads", icon: Upload, label: "External invoices", desc: "Upload bills from Tally / Excel for customers" },
        { to: "/employee/accounts/customers", icon: Users, label: "Customer master", desc: "Save addresses, defaults, GSTIN" },
        { to: "/employee/accounts/dues", icon: Wallet, label: "All dues", desc: "Aggregate outstanding across customers" },
    ],
};

export default function EmployeeHub() {
    const { user } = useAuth();
    const caps = user?.capabilities || [];
    const tiles = caps.flatMap(c => TILES[c] || []);

    return (
        <div data-testid="employee-hub">
            <div className="label-eyebrow text-sky-700">Welcome</div>
            <h1 className="font-serif text-4xl text-stone-900 mt-2">{user?.designation_name || "Employee"}</h1>
            <p className="text-sm text-stone-500 mt-1 mb-8">Logged in as {user?.name} · {user?.email}</p>

            {tiles.length === 0 ? (
                <div className="bg-white border border-stone-200 p-12 text-center">
                    <h3 className="font-serif text-2xl text-stone-900">No capabilities assigned yet</h3>
                    <p className="text-sm text-stone-500 mt-2">Ask admin to assign capabilities to your designation.</p>
                </div>
            ) : (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {tiles.map(t => (
                        <Link key={t.to} to={t.to} className="bg-white border border-stone-200 p-6 hover:border-sky-700 transition-colors" data-testid={`hub-tile-${t.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                            <t.icon className="w-6 h-6 text-sky-700 mb-3" />
                            <div className="font-serif text-2xl text-stone-900">{t.label}</div>
                            <p className="text-xs text-stone-500 mt-1">{t.desc}</p>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
